// 互动数据表头
export const interactDataTableHeader = [
  {
    title: '学校',
    colKey: 'schoolName',
    width: 200,
    ellipsis: true,
    fixed: 'left',
    show: true,
  },
  {
    title: '教师数量',
    colKey: 'teacherCount',
    width: 100,
    ellipsis: true,
    show: true,
  },
  {
    title: '班级数量',
    colKey: 'classCount',
    width: 100,
    ellipsis: true,
    show: true,
  },
  {
    title: '学生数量',
    colKey: 'studentCount',
    width: 100,
    ellipsis: true,
    show: true,
  },
  {
    title: '学科',
    colKey: 'selfDefineSubjecl',
    width: 200,
    ellipsis: true,
    show: false,
  },
  {
    title: '年级',
    colKey: 'selfDefineGrade',
    width: 200,
    ellipsis: true,
    show: false,
  },
  {
    // title: "授课次数",
    title: 'title-teaching',
    colKey: 'teachingCount',
    width: 130,
    ellipsis: true,
    show: true,
  },
  {
    title: 'teaching-time',
    colKey: 'dealTeachingTimeCount',
    width: 200,
    ellipsis: true,
    show: true,
  },
  {
    // title: "演示学程数",
    title: 'course-count',
    colKey: 'useCourseCount',
    width: 130,
    ellipsis: true,
    show: true,
  },
  {
    // title: "演示学程次数",
    title: 'course-number',
    colKey: 'useCourseNumberCount',
    width: 150,
    ellipsis: true,
    show: true,
  },
  {
    // title: "展示数",
    title: 'title-show-count',
    colKey: 'showCount',
    width: 100,
    ellipsis: true,
    show: true,
  },
  {
    // title: "文件推送数",
    title: 'title-push-count',
    colKey: 'pushFileCount',
    width: 130,
    ellipsis: true,
    show: true,
  },
  {
    // title: "广播大屏次数",
    title: 'broadcast-count',
    colKey: 'broadcastCount',
    width: 160,
    ellipsis: true,
    show: true,
  },
  {
    title: '版本覆盖数据',
    fixed: 'right',
    width: 400,
    colKey: 'operate',
    show: true,
  },
  {
    title: '版本覆盖数据',
    fixed: 'right',
    width: 200,
    align: 'center',
    colKey: 'newCoverData',
    show: false,
  },
]

// 版本覆盖率表头
export const versionCoverTableHeader = [
  {
    title: '版本号',
    colKey: 'version',
    width: 200,
  },
  {
    title: '覆盖率',
    colKey: 'rate',
    width: 200,
  },
  {
    title: '设备数',
    colKey: 'schoolCount',
    width: 200,
  },
]
